import {BaseDTO} from "./index";

export interface VehicleTypeDTO extends BaseDTO {
  vehicleTypeName: string;
  isHidden: number;
}
